module.exports = "<div class=\"weui_cell_hd\"><slot></slot></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/cells/cell-header.vue
 ** module id = 65
 ** module chunks = 0
 **/